import { render, staticRenderFns } from "./UpdateRouteData.vue?vue&type=template&id=645749e2&"
import script from "./UpdateRouteData.vue?vue&type=script&lang=js&"
export * from "./UpdateRouteData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports